module.exports = __webpack_public_path__ + "static/media/flip_card_logo.7d745acc.png";